<svg [style.width]="width()"
     [style.height]="height()"
     [style.color]="color()"
     viewBox="0 0 20 20"
     fill="none"
     stroke="currentColor"
     stroke-width="3"
     stroke-linecap="round"
     stroke-linejoin="round"
     xmlns="http://www.w3.org/2000/svg">
  <polyline points="4 10 8 14 16 6"></polyline>
</svg>
